module.exports = __webpack_public_path__ + "img/ueber-mich_1280.5d52360e.png";